var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalDeliveryNavIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.58699 -0.0020752C5.20608 0.000859482 9.635 1.83667 12.9002 5.10183C16.1654 8.36699 17.9997 12.7943 17.9999 17.4105C17.9999 18.1937 16.2754 18.1923 16.2754 17.4105C16.2754 8.44512 9.55445 1.72417 0.58699 1.7221C-0.195317 1.72763 -0.19601 -0.0020752 0.58699 -0.0020752Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.586731 3.06781C4.39168 3.07038 8.03992 4.58276 10.7295 7.27252C13.4191 9.96228 14.93 13.6093 14.93 17.4119C14.93 18.1951 13.2054 18.1951 13.2054 17.4119C13.2054 10.1409 7.85942 4.79474 0.586731 4.79267C-0.195577 4.79198 -0.195577 3.06781 0.586731 3.06781Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.586809 6.1723C3.56814 6.1745 6.42665 7.3595 8.53419 9.46691C10.6417 11.5743 11.8259 14.4317 11.8264 17.4112C11.8264 18.1937 10.1005 18.1937 10.1005 17.4112C10.1005 11.8547 6.14536 7.89785 0.586133 7.89646C-0.195482 7.89646 -0.195499 6.1723 0.586809 6.1723Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56997 11.1794L2.66059 11.9613L0.46875 9.72925L3.01713 9.97694L4.56997 11.1794Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92671 13.5796L6.01562 15.3785L8.30025 17.706L8.10017 15.155L6.92671 13.5796Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67004 12.3785L0.21582 17.7191L5.60058 15.3619L2.67004 12.3785Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45497 12.1613L0.188362 9.85388L0.0810547 17.3262L2.45497 12.1613Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81566 15.5826L0.607422 17.8658L8.08434 17.8928L5.81566 15.5826Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7113 13.3602L4.78391 11.3981L2.87451 12.1792L5.80438 15.1626L6.7113 13.3602Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalDeliveryNavIcon);
export default __webpack_public_path__ + "static/media/Digital_Delivery_Nav_Icon.fa25b272.svg";
export { ForwardRef as ReactComponent };